import {formatearDecimal} from '../util/util';

export const usd = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = "USD " + formatearDecimal(binding.value);
        } else{
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = "USD " + formatearDecimal(binding.value);
        } else{
            el.innerHTML = null
        }
    }
};




// WEBPACK FOOTER //
// ./src/directives/currency.js